<script lang="ts">
  import AppShell from '../components/AppShell.svelte';
  import FunnelPipeline from '../components/FunnelPipeline.svelte';

  let { params }: { params: { slug?: string } } = $props();
  const slug = $derived(params?.slug ?? '');
</script>

<AppShell active="funnels">
  <div class="mx-auto max-w-[1400px]">
    <div class="text-xs text-[var(--color-text-muted)] mb-2">
      <a href="#/funnels" class="text-[var(--color-pu)] no-underline hover:underline">Воронки</a> ›
      <span>{slug}</span>
    </div>
    <header class="mb-4 flex items-center justify-between gap-3 flex-wrap">
      <h1 class="text-2xl font-bold leading-tight">Pipeline</h1>
      <div class="inline-flex rounded-lg border border-[var(--color-border-3)] bg-white p-0.5 text-[11px] font-semibold">
        <a href="#/funnels/{slug}/pipeline" class="rounded-md bg-[var(--color-pu)] px-3 py-1.5 text-white no-underline">Pipeline</a>
        <a href="#/funnels/{slug}" class="rounded-md px-3 py-1.5 text-[var(--color-text-muted)] no-underline hover:bg-[var(--color-bg-3)]">Статистика</a>
      </div>
    </header>
    {#key slug}
      <FunnelPipeline {slug} />
    {/key}
  </div>
</AppShell>
